import chartUtils from '../../../utils/chart-utils';
import { getTooltipValue } from '../../../utils/tooltip';

var buildMultiAxisTooltip = function buildMultiAxisTooltip(seriesConfig, data) {
    var tipHeader = seriesConfig.StackOnField != null || seriesConfig.GroupOnField != null ? seriesConfig.FieldName : seriesConfig.SeriesName;

    if (seriesConfig.TipField != null && d[seriesConfig.TipField] != null) tipHeader = d[seriesConfig.TipField] + '<br/>' + tipHeader;

    var formatData = void 0;

    // To show tooltip for waterfall chart 'Total' data 
    if (data.options.isSum) {
        data.options[seriesConfig.FieldName] = data.y;
        formatData = data.y;
    } else formatData = data.options.y;

    var defaultTipText;
    if (seriesConfig.ShowDefaultTooltip) {
        if (seriesConfig.ShowPercentage) defaultTipText = '<span class="tip-header">' + tipHeader + ':</span><span class="tip-value"> ' + (Math.round(data.percentage * 10 / 10) + '%');else defaultTipText = '<span class="tip-header">' + tipHeader + ':</span><span class="tip-value"> ' + chartUtils.format(formatData, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat) + '</span>';
    } else defaultTipText = '';

    seriesConfig.Tooltip.TooltipConfigs.forEach(function (tipItem) {
        // var tipItem = seriesConfig.Tooltip.TooltipseriesConfigs[tipIndex];

        var tipValue = getTooltipValue(tipItem, data.options);

        if (tipItem.TipField == seriesConfig.FieldName && tipItem.AggregationType == "") tipValue = data.options[seriesConfig.FieldName];

        if (tipItem.TipField == seriesConfig.crumbFieldName && tipItem.AggregationType == "") tipValue = data.options[seriesConfig.crumbFieldName];

        if (tipItem.TipField == seriesConfig.CrumbDisplayFieldName && tipItem.AggregationType == "") tipValue = data.options[seriesConfig.CrumbDisplayFieldName];

        if (tipItem.TipField == seriesConfig.FieldName && tipItem.AggregationType == "") tipValue = data.options[seriesConfig.FieldName];

        data.options[tipItem.Id] = tipValue;
    });

    return defaultTipText;
};

export default buildMultiAxisTooltip;